import { AuthRequest, Method } from 'src/util/Request';
import { baseUrl, genericNetworkErrorHandler } from '.';
import { Report } from '@lanterds/types';
import { ModalReportForm } from 'src/components/Views/AdminView/Reports/EditReportDialog';

export const getReports = async () => {
    const url = `${baseUrl}/reports`;
    const res = await AuthRequest(url, Method.GET);

    if (res.ok) {
        const reports = await res.json();
        return reports.data;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const getReportTokens = async (reportName: string) => {
    const url = `${baseUrl}/reports/${reportName}`;
    const res = await AuthRequest(url, Method.GET);

    if (res.ok) {
        const report = await res.json();
        return report.data;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const getOsdManifestReportPdf = async (dueDate: string, routeNames: string[], signal: AbortSignal) => {
    const headers = {
        'Content-Type': 'application/json',
    };
    const url = `${baseUrl}/reports/fmtp/osd`;
    const res = await AuthRequest(url, Method.POST, headers, { dueDate, routeNames }, signal);

    if (res.ok) {
        const report = await res.json();
        return report;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const getOsdManifestRoutes = async (routeName: string, signal: AbortSignal) => {
    const url = `${baseUrl}/reports/fmtp/osd/routes?routeName=${encodeURIComponent(routeName)}`;
    const res = await AuthRequest(url, Method.GET, null, null, signal);

    if (res.ok) {
        const report = await res.json();
        return report;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const editReport = async (reportConfig: ModalReportForm, createNew: boolean) => {
    const headers = {
        'Content-Type': 'application/json',
    };
    const res = await AuthRequest(`${baseUrl}/admin/report`, createNew ? Method.POST : Method.PUT, headers, {
        report: reportConfig,
    });

    if (res.ok) {
        const reports = await res.json();
        return reports;
    } else {
        await genericNetworkErrorHandler(res);
    }
};
